import React from 'react';
import {
    InstructionWrapper,
    InstructionTitle,
    InstructionRowWrapper,
    Dot,
    Instruction,
} from './styles';

import CirclePurple from '@public/images/purple-circle.svg';

function index() {
    const InstructionRow = ({ text }: any) => {
        return (
            <InstructionRowWrapper>
                <Dot>
                    <CirclePurple />
                </Dot>
                <Instruction>{text}</Instruction>
            </InstructionRowWrapper>
        );
    };

    return (
        <InstructionWrapper>
            <InstructionTitle>Instructions:</InstructionTitle>
            <InstructionRow
                text={
                    'Pre-authorisation compulsary for FHPL, prior to planned admission and within 24hours for emergencies.'
                }
            />
            <InstructionRow text={'Out Patient treatment not covered.'} />
            <InstructionRow
                text={'Admission for Investigation/Evalution not covered.'}
            />
            <InstructionRow
                text={
                    'Leave back all claims related documents with Network Hospital.'
                }
            />
            <InstructionRow
                text={'Terms & Conditions of Insurance Company applicable'}
            />
            <InstructionRow text={'Refer Guide book for further details'} />
            <InstructionRow
                text={
                    'Cashless hospitalization in network hospital can be obtained in conjuction with this card, an authorization letter issued by FHPL and photo identification such as Voter ID, Drivers License etc.'
                }
            />
        </InstructionWrapper>
    );
}

export default index;
